
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";
import { MatDialogRef} from '@angular/material';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import {Questions} from "../classes/question";
import {Anomalies} from "../classes/anomaly";
import {SecondLanguageService} from "../shared/services/second-language.service";


@Component({
  selector: 'edit-anomaly-dialog',
  templateUrl: './edit-anomaly-dialog.component.html',
  styleUrls: ['edit-anomaly-dialog.component.css']
})
export class EditAnomalyDialogComponent {

  dispValue : string;
  questions : Questions[];
  anomaly : Anomalies;
  parentOptions : Options[];
  dependentOptions : Options[];
  languages : string[];
  dependentQuestion : number;
  relationPrimary : string = "";
  relationSecondary : string = "";
  valuePrimary : number;
  valueSecondary : number;
  parent:string;
  ageRange:string;

  constructor(@Inject(MAT_DIALOG_DATA) public data : any,public dialogRef: MatDialogRef<EditAnomalyDialogComponent>,private toastyService:ToastyService, private toastyConfig: ToastyConfig, private secondLanguageService : SecondLanguageService) {
    this.dispValue = data.dispValue;
    this.questions = data.questions;
    this.anomaly = data.anomaly;
    this.languages = this.secondLanguageService.getLanguages();

    if(this.anomaly.Rule.length > 0){

      if((this.dispValue && this.dispValue === 'Simple Anomaly')){

        if(this.questions[this.anomaly.Qn_Num - 1].Qn_Disp_Value === 'Number'){

          let rule = this.anomaly.Rule.split(' ');
          this.relationPrimary = rule[1];
          this.valuePrimary = parseInt(rule[2]);

        }else{

          let rule = this.anomaly.Rule.split(' ');

          if (this.questions[this.anomaly.Qn_Num - 1].Opt_Name.length > 0) {
            this.parentOptions = [];
            for(let j=0;j<this.questions[this.anomaly.Qn_Num -1].Opt_Name.length ;j++){
              let temp : Options = new Options;
              temp.checked = false;
              temp.src = '../../assets/images/check_box_unchecked.svg';
              temp.Qn = this.questions[this.anomaly.Qn_Num -1].Opt_Name[j];
              temp.index = j;
              this.parentOptions.push(temp);
            }
          }

          let optString = rule[2].substring(1,rule[2].length -1);
          let options = optString.split(',');
          for(let option of options){

            this.parentOptions[parseInt(option)].checked = true;
            this.parentOptions[parseInt(option)].src = '../../assets/images/check_box_checked.svg';

          }

        }

      }else{

        let rules = this.anomaly.Rule.split('&');
        let rule1;
        let rule2;
        if(parseInt(rules[0].split(" ")[0]) === this.anomaly.Qn_Num){
          rule1 = rules[0].trim();
          rule2 = rules[1].trim();
        }else{
          rule1 = rules[1].trim();
          rule2 = rules[0].trim();
        }


        let param1 = rule1.split(' ');

        if(this.questions[parseInt(param1[0]) - 1].Qn_Disp_Value === 'Number'){

          this.relationPrimary = param1[1];
          this.valuePrimary = parseInt(param1[2]);

        }else{


          if (this.questions[parseInt(param1[0]) - 1].Opt_Name.length > 0) {
            this.parentOptions = [];
            for(let j=0;j<this.questions[parseInt(param1[0]) -1].Opt_Name.length ;j++){
              let temp : Options = new Options;
              temp.checked = false;
              temp.src = '../../assets/images/check_box_unchecked.svg';
              temp.Qn = this.questions[parseInt(param1[0]) -1].Opt_Name[j];
              temp.index = j;
              this.parentOptions.push(temp);
            }
          }

          let optString = param1[2].substring(1,param1[2].length -1);
          let options = optString.split(',');
          for(let option of options){

            this.parentOptions[parseInt(option)].checked = true;
            this.parentOptions[parseInt(option)].src = '../../assets/images/check_box_checked.svg';

          }

        }

        let param2 = rule2.split(' ');
        this.dependentQuestion = parseInt(param2[0]);

        if(this.questions[parseInt(param2[0]) - 1].Qn_Disp_Value === 'Number'){

          this.relationSecondary = param2[1];
          this.valueSecondary = parseInt(param2[2]);

        }else{


          if (this.questions[parseInt(param2[0]) - 1].Opt_Name.length > 0) {
            this.dependentOptions = [];
            for(let j=0;j<this.questions[parseInt(param2[0]) -1].Opt_Name.length ;j++){
              let temp : Options = new Options;
              temp.checked = false;
              temp.src = '../../assets/images/check_box_unchecked.svg';
              temp.Qn = this.questions[parseInt(param2[0]) -1].Opt_Name[j];
              temp.index = j;
              this.dependentOptions.push(temp);
            }
          }

          let optString = param2[2].substring(1,param2[2].length -1);
          let options = optString.split(',');
          for(let option of options){

            this.dependentOptions[parseInt(option)].checked = true;
            this.dependentOptions[parseInt(option)].src = '../../assets/images/check_box_checked.svg';

          }

        }




      }

    }

  }


  anomalyParentSelected(i : number){
    if(!this.anomaly.Qn_Num || this.anomaly.Qn_Num !== i) {
      this.anomaly.Qn_Num = i;
      if (this.questions[i - 1].Qn_Disp_Value !== 'Number') {
        if (this.questions[i - 1].Opt_Name.length > 0) {
          this.parentOptions = [];
          for(let j=0;j<this.questions[i -1].Opt_Name.length ;j++){
            let temp : Options = new Options;
            temp.checked = false;
            temp.src = '../../assets/images/check_box_unchecked.svg';
            temp.Qn = this.questions[i -1].Opt_Name[j];
            temp.index = j;
            this.parentOptions.push(temp);
          }
        }
      }
    }
  }

  anomalyDependentSelected(i : number){
    if(!this.dependentQuestion || this.dependentQuestion !== i) {
      this.dependentQuestion = i;
      if (this.questions[i - 1].Qn_Disp_Value !== 'Number') {
        if (this.questions[i - 1].Opt_Name.length > 0) {
          this.dependentOptions = [];
          for(let j=0;j<this.questions[i -1].Opt_Name.length ;j++){
            let temp : Options = new Options;
            temp.checked = false;
            temp.src = '../../assets/images/check_box_unchecked.svg';
            temp.Qn = this.questions[i -1].Opt_Name[j];
            temp.index = j;
            this.dependentOptions.push(temp);
          }
        }
      }
    }
  }

  parentOptionSelected(i : number){
    if(this.parentOptions[i].checked){
      this.parentOptions[i].checked = false;
      this.parentOptions[i].src = '../../assets/images/check_box_unchecked.svg';
    }else{
      this.parentOptions[i].checked = true;
      this.parentOptions[i].src = '../../assets/images/check_box_checked.svg';
    }
  }

  dependentOptionSelected(i : number){
    if(this.dependentOptions[i].checked){
      this.dependentOptions[i].checked = false;
      this.dependentOptions[i].src = '../../assets/images/check_box_unchecked.svg';
    }else{
      this.dependentOptions[i].checked = true;
      this.dependentOptions[i].src = '../../assets/images/check_box_checked.svg';
    }
  }

  heading(event : any){
    this.anomaly.Msg_H = event.target.value;
  }

  messageP(event : any){
    this.anomaly.Msg = event.target.value;
  }

  messageS(event : any){
    this.anomaly.Msg_S = event.target.value;
  }



  primaryRelation(rel : string){
    this.relationPrimary = rel;
  }

  secondaryRelation(rel : string){
    this.relationSecondary = rel;
  }

  primaryValuePressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  primaryValueKeyup(event: any){

    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  primaryValueEntered(event : any){
    if(event.target.value > 0)
      this.valuePrimary = parseInt(event.target.value);
    else
      this.valuePrimary = null;
  }

  secondaryValuePressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  secondaryValueKeyup(event: any){

    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  secondaryValueEntered(event : any){
    if(event.target.value > 0)
      this.valueSecondary = parseInt(event.target.value);
    else
      this.valueSecondary = null;
  }


  save(){

    let rule :string = "";
    if(!this.anomaly.Qn_Num){
      this.addToast(true,false,false,false,false,false,false);
      return;
    }else{
      rule = rule + this.anomaly.Qn_Num;
    }

    if(this.questions[this.anomaly.Qn_Num -1].Qn_Disp_Value === 'Number'){

      if(this.relationPrimary.length === 0){
        this.addToast(false,true,false,false,false,false,false);
        return;
      }else{

        rule = rule + " "+this.relationPrimary;
      }

      if(!this.valuePrimary){
        this.addToast(false,false,true,false,false,false,false);
        return;
      }else{
        rule = rule + " "+this.valuePrimary;
      }

    }else{

      let found : boolean = false;

      rule = rule + " = {";

      for(let option of this.parentOptions){

        if(option.checked){

          if(!found){
            rule = rule + option.index;
            found = true;
          }else{
            rule = rule + ","+option.index;
          }

        }


      }
      if(!found){
        this.addToast(false,false,false,true,false,false,false);
        return;
      }else{
        rule = rule + "}";
      }

    }

    if(this.dispValue === 'Dependent Anomaly'){

      rule = rule + " & ";

      if(!this.dependentQuestion){
        this.addToast(false,false,false,false,true,false,false);
        return;
      }else{

        rule = rule + " "+this.dependentQuestion;
      }


      if(this.questions[this.dependentQuestion -1].Qn_Disp_Value === 'Number'){

        if(this.relationSecondary.length === 0){
          this.addToast(false,true,false,false,false,false,false);
          return;
        }else{

          rule = rule + " "+this.relationSecondary;
        }

        if(!this.valueSecondary){
          this.addToast(false,false,true,false,false,false,false);
          return;
        }else{
          rule = rule + " "+this.valueSecondary;
        }

      }else{

        let found : boolean = false;

        rule = rule + " = {";

        for(let option of this.dependentOptions){

          if(option.checked){

            if(!found){
              rule = rule + option.index;
              found = true;
            }else{
              rule = rule + ","+option.index;
            }

          }


        }


        if(!found){
          this.addToast(false,false,false,true,false,false,false);
          return;
        }else{
          rule = rule + "}";
        }

      }



    }

    this.anomaly.Rule = rule;

    if(!this.anomaly.Msg_H || this.anomaly.Msg_H.length === 0){
      this.addToast(false,false,false,false,false,true,false);
      return;
    }

    if(!this.anomaly.Msg || this.anomaly.Msg.length === 0){
      this.addToast(false,false,false,false,false,false,true);
      return;
    }

    if(this.languages[1].length > 0){

      if(!this.anomaly.Msg_S || this.anomaly.Msg_S.length === 0){
        this.addToast(false,false,false,false,false,false,true);
        return;
      }
    }

    this.dialogRef.close(this.anomaly);

  }


  addToast(noParent : boolean, noRelation : boolean, noValue : boolean, selectOption : boolean, noDepQues : boolean,heading : boolean, message : boolean) {


    if(noParent){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Select the question on which to give anomaly",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(noRelation){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Specify the relation to value",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(noValue){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Please provide the value for number question",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(selectOption){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Please Select at least one option",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(noDepQues){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Please select dependent question",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(heading){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Please enter anomaly heading",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(noDepQues){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Please enter anomaly message",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }
  }

}

class Options{

  checked : boolean;
  src : string;
  Qn : string;
  index : number;
}



// WEBPACK FOOTER //
// ./src/app/editAnomalyDialog/edit-anomaly-dialog.component.ts